import React from 'react'
import { Link } from 'react-router-dom'

const LinkWithScrollTop = ({ onClick, optionalRef = null, ...props }) => (
  <Link
    data-testid="LWST"
    onClick={(e) => {
      // only snap to the top of the page if they're not ctrl+clicking, which opens a new tap elsewhere
      if (!e.ctrlKey && !e.metaKey) {
        window.scrollTo(0, 0)
      }
      if (onClick) onClick()
    }}
    onKeyDown={(e) => {
      if (e.key === 'Enter') {
        if (!e.ctrlKey && !e.metaKey) {
          window.scrollTo(0, 0)
        }
        if (onClick) onClick()
      }
    }}
    ref={optionalRef}
    {...props}
  />
)

export default LinkWithScrollTop
